// src/services/notificationDefinitionsApi.js
import { api } from './apiServices';

// Requires the admin permission `admin_user:manage`.

export const listNotificationDefinitions = () =>
  api.get('/admin/notification-definitions');

export const updateNotificationDefinition = (id, data) =>
  api.patch(`/admin/notification-definitions/${id}`, data);
